import React from 'react';

import { ServerSideRendered } from './ServerSideRendered';

import * as introSection from '../../intro-section.frontend';
import * as constructingTheFuture from '../../constructing-the-future.frontend';
import * as baseSection from '../../base-section.frontend';
import * as baseComponent from '../../base-section.frontend/BaseComponent';
import * as readMore from '../../read-more.frontend';
import * as bigNumber from '../../big-number.frontend';
import * as story from '../../stories.frontend/Story';
import * as stories from '../../stories.frontend/Stories';
import * as highcharts from '../../highcharts.frontend';
import * as shortcode from '../../shortcode.frontend';
import * as tablePress from '../../table-press.frontend';
import { relatedSDG, relatedSDGs } from '../../related-sdgs.frontend';
import * as wpGroup from '../../wp-group';
import * as wpParagraph from '../../wp-paragraph';
import * as heroSection from '../../hero-section.fronend';
import * as boxedSection from '../../boxed-section.frontend';
import * as wpImage from '../../wp-image';
import * as wpYoutube from '../../wp-youtube';
// import * as example from '../../example.frontend';

const relations = [];

const newRelation = block => {
  if (!block) return;

  const { name, renderer, providerNameSlug = null } = block;

  const relation = { name: name, renderer: renderer, slug: providerNameSlug };

  relations.push(relation);
};

export function registerRelations() {
  [
    introSection,
    constructingTheFuture,
    baseSection,
    baseComponent,
    readMore,
    bigNumber,
    story,
    stories,
    highcharts,
    shortcode,
    relatedSDG,
    relatedSDGs,
    tablePress,
    wpGroup,
    wpParagraph,
    heroSection,
    boxedSection,
    wpImage,
    wpYoutube,
    // example,
  ].forEach(newRelation);
}

registerRelations();

export function Block({ as, data, ...rest }) {
  const relation = as ? { renderer: as } : relations.find(r => handleRelation(data, r));

  // console.log(`${data.blockName} -> ${relation && relation.name}`);

  const { renderer: Tag } = { renderer: relation ? relation.renderer : ServerSideRendered };

  return <Tag data={data} {...rest} />;
}

function handleRelation(data, relation) {
  const { blockName, attributes = null } = data;

  return blockName == relation.name && relation.slug != null
    ? relation.slug == attributes.providerNameSlug
    : relation.name == blockName;
}
